import {Component, OnInit, Inject} from '@angular/core';
import {Option} from 'app/core/contracts/models/option';

import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Email } from 'src/app/core/contracts/models/email';
import { TypeEmailService } from 'src/app/core/services/api/type-email.service';
import { emailRegEx } from 'src/app/core/utils/patterns';

@Component({
    selector: 'app-types-of-emails-form',
    templateUrl: './types-of-emails-form.component.html',
    styleUrls: ['./types-of-emails-form.component.scss']
})
export class TypesOfEmailsFormComponent implements OnInit {
    readonly emailPattern = emailRegEx;

    emails: Option[] = [];
    email: Email = {
        idTipoEmail: null,
        tipo_email: null,
        email: null
    };

    title = 'Agregar correo';
    buttonSubmit = true;

    constructor(
        public dialogRef: MatDialogRef<TypesOfEmailsFormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Email,
        private typeEmailService: TypeEmailService,
    ) {
        if (data) {
            this.title = 'Editar correo';
            this.email.tipo_email = data.tipo_email;
            this.email.idTipoEmail = data.tipo_email.id;
            this.email.email = data.email;
        }
    }

    ngOnInit(): void {

        this.typeEmailService.getAll().subscribe((response: any) => {
            this.emails = response.data;
        });
    }

    onSubmit() {
        this.email.tipo_email = this.emails.find(e => e.id === this.email.idTipoEmail);
        this.dialogRef.close({...this.email});
    }

    cancel() {
        this.dialogRef.close(this.data);
    }
}
